import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { Actions, MenuService } from '../../../service/menu-service/menu.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ToastrService } from 'ngx-toastr';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { isEdit, SortColumnNames, SortTypes, getDistanceFromLatLon, parseDisplayName } from 'src/app/utils/utils.common';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { MemberService } from 'src/app/service/member-service/member.service';
import { FleetService } from 'src/app/service/fleet-service/fleet.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: "app-unassigned",
  templateUrl: "./unassigned.component.html",
  styleUrls: ["./unassigned.component.css"],
})
export class UnassignedComponent implements OnInit, OnDestroy {
  duration = 10 * 1000; // 10 seconds
  dataList = [];
  subMenus = [];
  filterdataList = [];
  todayDate;
  memberList:any
  status = "";
  isShowAllTrips = false;
  showSlideFilter = false;
  assignModalObj;
  search: any;
  componentType;
  tripIndex = -1;
  timeZone;
  settingInterval;
  secondaryCompType = null;
  specialRate;
  user;
  selectedTrip;
  tripLogObj;
  selectedTrips = [];
  orderBy = "scheduleTime";
  view = "list";
  selectedDropdownIndex: any;
  tripDetailModalObj;
  completedTripModalObj;
  skip = 0;
  selectedTripId;
  isAllTripsSelected: boolean = false;
  tripPurposesAndAddons;
  selectedTripPurpose = '';
  selectedLOS = '';
  selectedSpaceType = '';
  appointmentTypes;
  selectedAptType;
  patients;
  selectedPatient = "";
  drivers;
  selectedDriver = "";
  preLevelOfServices = {};
  preSpaceTypes = {};
  levelOfServiceList = [];
  filteredLevelOfService = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];
  cancelTripModalObj
  editTripModalObj: any;
  isEditPermission = true;
  willCallObj: any;
  toggleActionButtons = false;
  preFleetList:any;
 isOpen = false;
  menus;
  cancelReasonModalObj;
  SortColumnNames = SortColumnNames;
  SortTypes = SortTypes;
  sortColumn = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  isNewTripId:any = '';
  showBadPhoneNumber: boolean = false;
  showConfirmedTrip: boolean = false;
  showVoiceMail: boolean = false;
  thirdPartyDrivers = false;
  hideThirdParty = false;
  isEnabledOneHourException = true;
  isMissingLOS = false;
  isMissingAppointmentType = false;
  isMissingAppointmentTime = false;
  isMissingAddress = false;
  isDuplicateAddress = false;
  isDuplicateTrip = false;
  Actions = Actions;
  hasPermissions;
  
  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private menuService: MenuService,
    private toastr: ToastrService,
    private csvService: CsvService,
    private memberService: MemberService,
    private fleetService: FleetService,
    private router: Router
  ) { }

  ngOnInit() {
    const navState = history.state;
    if (navState && navState.tripId) {
      this.isNewTripId = navState.tripId;
    }

    this.getUser();
    this.setPermissions();
    this.listenSocket();
    this.getConfigurations();
    this.getFleetList();
  }

  setPermissions() {
    this.sharedDataService
      .getPermissions()
      .subscribe((permissions) => {
        this.hasPermissions = permissions;
      });
  }
  

  setTripStatus(status, isSkipCheck?) {
    if (!isSkipCheck && this.status === status) return;
    this.skip = 0;
    this.clearTrips();
    this.selectedDropdownIndex = -1;
    this.status = status;
    this.getTrips();
    this.reset();
  }

  moveToItem(): void {
    if (this.isNewTripId) {
      // Timeout to ensure DOM is ready
      setTimeout(() => {
        const element = document.getElementById(this.isNewTripId!);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          element.classList.add('highlight-trip');
        }
      }, 2000);
    }
  }

  reset() {
    this.selectedTrips = [];
    this.orderBy = "scheduleTime";
  }

  getConfigurations() {
    this.assignTripService
      .getConfigurations({status: 'active'})
      .subscribe(data => {
        if (data) {
          if(data.levelofservices && data.levelofservices.length){
            this.levelOfServiceList = data.levelofservices;
            this.preLevelOfServices = data.levelofservices.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }

          if(data.spacetypes && data.spacetypes.length){
            this.spaceTypeList = data.spacetypes;
            this.preSpaceTypes = data.spacetypes.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
          
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.menus = this.menuService.getMenu(this.user.roles[0]);
          this.hideThirdParty = data.cooperate ? data.cooperate.hide3rdPartyDriver :  data.hide3rdPartyDriver;
          this.isEditPermission = isEdit(data);
          if(data.company)
          this.timeZone = data.company.timeZone;
        
          // this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getStaffRoles();
          if (this.user.hasOwnProperty("isListView") && this.user.isListView) {
            this.view = "list";
          }

          if (this.user.company 
            && this.user.company.hasOwnProperty('hideOneHourException')
            && this.user.company.hideOneHourException
          ) {
            this.isEnabledOneHourException = false;
          }
        }
      });
  }



  getTrips() {

    // this.filterdataList = [];
    // this.dataList = [];
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: this.status,
      date: this.todayDate,
      skip: this.skip,
    };
    // this.store.dispatch(new GetUnassignedList(object));
    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.clearTrips();
          }
          if (data && object.status === this.status) {
            // this.search = '';
            data.forEach((trip) => {
              trip.isVisibleWillcallActivation = moment(trip.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
              this.setTripMissingFlags(trip);
            });
            this.dataList = [...data, ...this.dataList];
            this.filterdataList = this.dataList;
            this.group(true);


            if (data.length) {
              this.skip += data.length;
              this.getTrips();
            } else {
                this.moveToItem();
              this.skip = 0;
             
              this.drivers = [];
              this.tripPurposesAndAddons = [];
              let levelOfServices = [];
              let spaceTypes = [];
              this.appointmentTypes = [];
              this.patients = [];
              this.dataList.forEach(trip => {
                if (trip.driver) {
                  this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName });
                }

                if (trip.addonServices && trip.addonServices.length) {
                  for (let addon of trip.addonServices){
                    this.tripPurposesAndAddons.push(addon.title);
                 }
                }

                if (trip.los) {
                  levelOfServices.push(trip.los);
                }

                if (trip.spaceType) {
                  spaceTypes.push(trip.spaceType);
                }

                if (trip.tripReason) {
                  // remove the item having empty string
                  if (trip.tripReason && trip.tripReason.length) {
                    this.appointmentTypes.push(...trip.tripReason);
                  }
                }
                  if (trip.priorityClient) {
                    this.patients.push({ displayName: trip.priorityClient.displayName });
                  }
              });



                if (this.selectedLOS)
                levelOfServices.push(this.selectedLOS)

                if (this.selectedSpaceType)
                spaceTypes.push(this.selectedSpaceType)

                if (this.selectedAptType)
                this.appointmentTypes.push(this.selectedAptType)

                if (this.selectedPatient)
                this.patients.push(this.selectedPatient)



              this.drivers = _.uniq(this.drivers, '_id').sort();
              this.tripPurposesAndAddons = [...new Set(this.tripPurposesAndAddons)].sort();
              levelOfServices = _.uniq(levelOfServices).sort();
              spaceTypes = _.uniq(spaceTypes).sort();
              this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
              this.patients = _.uniq(this.patients, 'displayName').sort();

              if(levelOfServices && levelOfServices.length){
                this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
              }

              if(spaceTypes && spaceTypes.length){
                this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
              }

              if (this.status === 'unassigned')
                this.selectedDriver = "";

              this.setDuplicateTripFlags();
            }
          }
          this.filterTripsByModel();

          
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.dataList = [];
  }

  listenSocket() {
    this.socketService
      .addListener(Events.DROP_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          const indexOfDataList = _.findIndex(this.dataList, {
            _id: data.assignId,
          });

          if (indexOfDataList > -1) this.dataList.splice(indexOfDataList, 1);

          const indexOfFilterdataList = _.findIndex(this.filterdataList, {
            _id: data.assignId,
          });
          if (indexOfFilterdataList > -1)
            this.filterdataList.splice(indexOfFilterdataList, 1);

          this.setDuplicateTripFlags();
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          this.dataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
            }
          });
          this.filterdataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
            }
          });
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.GET_DRIVER_ESTIMATED_FARE)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          const fares = data.fares;

          var message = `Company Fare: $${fares.brokerRate || fares.customerSpecialRate
            } and Driver Fare: $${fares.driverRate || 0}`;

          sweetAlert(
            "Alert",
            `Are you sure you want to update ${message}?`,
            "warning",
            "Yes",
            "No"
          ).then((result: any) => {
            if (result.value) {
              // sweetAlert('Success', 'Fare Calculated Successfully', 'success', 'OK')
              const payload = {
                driverFareDetail: { jobFee: fares.driverRate },
                jobFareDetail: {
                  jobFee: fares.brokerRate || fares.customerSpecialRate,
                },
              };
            }
          });
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        // console.log(data);
        // console.log("error message check", this.filterdataList)
        // console.log("error message data check", data)
        // console.log("error message data length check", this.filterdataList.length)
        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
              // console.log("error message loadedMessage check", selectedTrip.loadedMessage)
            }
          }

          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  onDateChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.todayDate = event.toISOString();
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getTrips();
  }

  onTimeChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.todayDate = event.toISOString();
    this.todayDate = [
      event[0].toISOString(),
      event[1].toISOString(),
    ];
    this.getTrips();
  }

  onResetTime() {
    this.reset();
    this.skip = 0;
    this.clearTrips();

    this.todayDate = [
      moment(this.todayDate[0]).startOf("day").toISOString(),
      moment(this.todayDate[1]).endOf("day").toISOString(),
    ];

    this.getTrips();
  }

  getTimeRestrictions(){
  return {min: moment(this.todayDate[0]).startOf("day").toISOString(),  max: moment(this.todayDate[1]).endOf("day").toISOString() }
  }

  setTripFilter(tripType) {
    this.filterTripsByModel();
  }

 
  getSelectedTrips() {
    return this.dataList
      .filter((trip) => trip.isSelected);

  }

  group(isNotFromButton?) {
    if (this.filterdataList && this.filterdataList.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filterdataList.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filterdataList.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }



  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterTrips();
  }

  filterTrips() {
    this.filterdataList = this.dataList.filter(trip => {
      let isDriverExist = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isAptTypeExist = true;
      let isPatientExist = true;
      let isThirdParty = true;
      let isMissingLos = true;
      let isMissingAptType = true;
      let isMissingAptTime = true;
      let isMissingAddress = true;
      let isDuplicateAddress = true;
      let isDuplicateTrip = true;
      const isBadPhoneOk   = this.showBadPhoneNumber && !!trip.badPhoneNumber;
      const isConfirmedOk  = this.showConfirmedTrip  && !!trip.isConfirmedTrip;
      const isVoiceMailOk = this.showVoiceMail && !!trip.isVoiceMail;

      isThirdParty  = this.thirdPartyDrivers && trip.driver && trip.driver.type === 'thirdParty';

      const anyFlagSelected = this.showBadPhoneNumber || this.showConfirmedTrip || this.showVoiceMail || this.thirdPartyDrivers;

      if (this.isMissingLOS) {
        isMissingLos = this.isTripMissingLOS(trip);
      }

      if (this.isMissingAppointmentType) {
        isMissingAptType = this.isTripMissingAppointmentType(trip);
      }

      if (this.isMissingAppointmentTime) {
        isMissingAptTime = this.isTripMissingAppointmentTime(trip);
      }

      if (this.isMissingAddress) {
        isMissingAddress = this.isTripMissingAddress(trip);
      }

      if (this.isDuplicateAddress) {
        isDuplicateAddress = this.isTripDuplicateAddress(trip);
      }

      if (this.isDuplicateTrip) {
        isDuplicateTrip = trip.isDuplicateTrip === true;
      }

      if (trip.driver && trip.driver._id && this.selectedDriver && this.selectedDriver.length) {
        isDriverExist = this.selectedDriver.includes(trip.driver._id);
      }

      if (trip.priorityClient && trip.priorityClient.displayName && this.selectedPatient && this.selectedPatient.length) {
        isSpaceTypeExist = this.selectedPatient.includes(trip.priorityClient.displayName);
      }

      if (trip.spaceType && this.selectedSpaceType && this.selectedSpaceType.length) {
        isPatientExist = this.selectedSpaceType.includes(trip.spaceType);
      }

      if (trip.tripReason && this.selectedAptType && this.selectedAptType.length) {
        isAptTypeExist = trip.tripReason.some(item => this.selectedAptType.includes(item));
      }

      if (trip.los && this.selectedLOS && this.selectedLOS.length) {
        islosExist = this.selectedLOS.includes(trip.los);
      }

      if (
        isMissingLos &&
        isMissingAptType &&
        isMissingAptTime &&
        isMissingAddress &&
        isDuplicateAddress &&
        isDuplicateTrip &&
        isDriverExist &&
        isPatientExist &&
        isSpaceTypeExist &&
        isAptTypeExist &&
        isCorporateExist &&
        islosExist &&
        (!anyFlagSelected || isBadPhoneOk || isConfirmedOk || isVoiceMailOk || isThirdParty)
      ) {
        return true;
      } else {
        return false;
      }
    });
  }

  setTripMissingFlags(trip: any): void {
    if (!trip) {
      return;
    }
    trip.isMissingLOS = this.checkTripMissingLOS(trip);
    trip.isMissingAppointmentType = this.checkTripMissingAppointmentType(trip);
    trip.isMissingAppointmentTime = this.checkTripMissingAppointmentTime(trip);
    trip.isMissingAddress = this.checkTripMissingAddress(trip);
    trip.isDuplicateAddress = this.checkTripDuplicateAddress(trip);
  }

  isTripMissingLOS(trip: any): boolean {
    if (trip && typeof trip.isMissingLOS === 'boolean') {
      return trip.isMissingLOS;
    }
    return this.checkTripMissingLOS(trip);
  }

  checkTripMissingLOS(trip: any): boolean {
    return !trip || !trip.los || (typeof trip.los === 'string' && trip.los.trim() === '');
  }

  isTripMissingAppointmentType(trip: any): boolean {
    if (trip && typeof trip.isMissingAppointmentType === 'boolean') {
      return trip.isMissingAppointmentType;
    }
    return this.checkTripMissingAppointmentType(trip);
  }

  checkTripMissingAppointmentType(trip: any): boolean {
    if (!trip || !trip.tripReason) {
      return true;
    }
    if (Array.isArray(trip.tripReason)) {
      if (trip.tripReason.length === 0) {
        return true;
      }
      return !trip.tripReason.some(function(item) {
        return item !== null && item !== undefined && (typeof item !== 'string' || item.trim() !== '');
      });
    }
    if (typeof trip.tripReason === 'string') {
      return trip.tripReason.trim() === '';
    }
    return false;
  }

  isTripMissingAppointmentTime(trip: any): boolean {
    if (trip && typeof trip.isMissingAppointmentTime === 'boolean') {
      return trip.isMissingAppointmentTime;
    }
    return this.checkTripMissingAppointmentTime(trip);
  }

  checkTripMissingAppointmentTime(trip: any): boolean {
    if (!trip || !trip.appointmentTime) {
      return true;
    }
    if (typeof trip.appointmentTime === 'string' && trip.appointmentTime.trim() === '') {
      return true;
    }
    return !moment(trip.appointmentTime).isValid();
  }

  isAddressMissing(address: any, lat?: any, lng?: any): boolean {
    if (!address || (typeof address === 'string' && address.trim() === '')) {
      return true;
    }
    if (lat === null || lat === undefined || lat === '' || lng === null || lng === undefined || lng === '') {
      return true;
    }
    const numLat = Number(lat);
    const numLng = Number(lng);
    if (isNaN(numLat) || isNaN(numLng)) {
      return true;
    }
    if (numLat === 0 && numLng === 0) {
      return true;
    }
    return false;
  }

  isTripMissingAddress(trip: any): boolean {
    if (trip && typeof trip.isMissingAddress === 'boolean') {
      return trip.isMissingAddress;
    }
    return this.checkTripMissingAddress(trip);
  }

  checkTripMissingAddress(trip: any): boolean {
    if (!trip) {
      return true;
    }
    const isPickupMissing = this.isAddressMissing(
      trip.jobOriginAddress,
      trip.jobOriginLatitude,
      trip.jobOriginLongitude
    );
    if (isPickupMissing) {
      return true;
    }
    return this.isAddressMissing(
      trip.jobDestinationAddress,
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude
    );
  }

  isTripDuplicateAddress(trip: any): boolean {
    if (trip && typeof trip.isDuplicateAddress === 'boolean') {
      return trip.isDuplicateAddress;
    }
    return this.checkTripDuplicateAddress(trip);
  }

  checkTripDuplicateAddress(trip: any): boolean {
    if (!trip) {
      return false;
    }
    if (
      this.isAddressMissing(trip.jobOriginAddress, trip.jobOriginLatitude, trip.jobOriginLongitude) ||
      this.isAddressMissing(trip.jobDestinationAddress, trip.jobDestinationLatitude, trip.jobDestinationLongitude)
    ) {
      return false;
    }

    const originAddr = this.normalizeAddress(trip.jobOriginAddress);
    const destAddr = this.normalizeAddress(trip.jobDestinationAddress);

    if (originAddr && destAddr && originAddr === destAddr) {
      return true;
    }

    const originLat = Number(trip.jobOriginLatitude);
    const originLng = Number(trip.jobOriginLongitude);
    const destLat = Number(trip.jobDestinationLatitude);
    const destLng = Number(trip.jobDestinationLongitude);

    if (!isNaN(originLat) && !isNaN(originLng) && !isNaN(destLat) && !isNaN(destLng)) {
      if (originLat === destLat && originLng === destLng) {
        return true;
      }
      if (getDistanceFromLatLon(originLat, originLng, destLat, destLng) < 0.01) {
        return true;
      }
    }

    return false;
  }

  normalizeAddress(address: any): string {
    return (address || '').toString().trim().toLowerCase();
  }

  // Same member (normalized name), same calendar day in the user's timezone, same pickup and drop-off
  getDuplicateTripKey(trip: any): string {
    if (!trip || !trip.scheduleTime || !trip.priorityClient || !trip.priorityClient.displayName) {
      return '';
    }

    const parsed = parseDisplayName(trip.priorityClient.displayName);
    const memberName = [parsed.firstName, parsed.lastName]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    const originAddr = this.normalizeAddress(trip.jobOriginAddress);
    const destAddr = this.normalizeAddress(trip.jobDestinationAddress);

    if (!memberName || !originAddr || !destAddr) {
      return '';
    }

    const dateKey = moment(trip.scheduleTime).tz(this.timeZone).format('MM/DD/YYYY');
    return [memberName, dateKey, originAddr, destAddr].join('||');
  }

  setDuplicateTripFlags(): void {
    const keys = this.dataList.map((trip) => this.getDuplicateTripKey(trip));
    const counts = {};
    keys.forEach((key) => {
      if (key) {
        counts[key] = (counts[key] || 0) + 1;
      }
    });
    this.dataList.forEach((trip, i) => {
      trip.isDuplicateTrip = !!keys[i] && counts[keys[i]] > 1;
    });
  }

  // Keeps dataList in sync with a trip replaced in filterdataList
  replaceTripInDataList(updatedTrip: any): void {
    const idx = this.dataList.findIndex((t) => t._id === updatedTrip._id);
    if (idx > -1) {
      this.dataList[idx] = updatedTrip;
    }
  }

  removeTripFromDataList(tripId: any): void {
    const idx = this.dataList.findIndex((t) => t._id === tripId);
    if (idx > -1) {
      this.dataList.splice(idx, 1);
    }
  }

  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }

  ngOnDestroy(): void {
    clearInterval(this.settingInterval);
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  getStaffRoles() {
    if (this.user && this.user.roles) {
      if (typeof this.user.roles === "string") {
        if (this.user.sRoles)
          this.subMenus = this.menuService.getAssignedSubMenu(this.user.sRoles);
        else
          this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles);
      } else if (typeof this.user.roles === "object") {
        this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles[0]);
      }
    }

    if (this.subMenus && this.subMenus.length) {
      if (this.subMenus[0].value === "all" && this.subMenus.length > 1)
        this.status = this.subMenus[2].value;
      else this.status = this.subMenus[0].value;

      this.getTrips();
    }
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  getETA(trip) {
    this.assignTripService
      .getETA(trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          trip.etaMessage = data.etaMessage;
        }
      });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active'})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleetList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  setModalContent(trips, type, ind?) {
    if (trips)
      this.assignModalObj = trips;
    else
      this.assignModalObj = this.getSelectedTrips().map((trip) => trip._id);

    this.secondaryCompType = null;
    if (ind >= 0) {
      this.tripIndex = ind;
    }
    if (type === "companyNote") {
      this.componentType = type;
    } else if (type === "dsr") {
      this.specialRate = JSON.parse(JSON.stringify(this.assignModalObj));
      this.componentType = type;
    } else if (type === "Multiple Assign") {
      this.componentType = type;
      this.secondaryCompType = this.status;
    } else {
      if (this.status === "hanging") {
        this.componentType = "hanging";
      } else if (this.status === "cancelled") {
        this.componentType = "cancelled";
      } else if (this.status === "archived") {
        this.componentType = "archived";
      } else if (this.status === "all") {
        this.componentType = "all";
      } else {
        this.componentType = type;
      }
    }
  }
  

  editTrip(assign) {
    this.editTripModalObj = assign._id;
  }


  onEditTrip(event) {
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      // const index = this.filterdataList.findIndex(event._id);
      const rangeStartDate = moment(this.todayDate[0]).tz(this.timeZone);
      const rangeEndDate = moment(this.todayDate[1]).tz(this.timeZone);
      const isBetween = moment(event.scheduleTime).tz(this.timeZone).isBetween(rangeStartDate, rangeEndDate);
      
      if (!isBetween) {
        this.filterdataList.splice(idx, 1);
        this.removeTripFromDataList(event._id);
      } else {
        event.isVisibleWillcallActivation = moment(event.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
        this.setTripMissingFlags(event);
        this.filterdataList[idx] = event;
        this.replaceTripInDataList(event);
      }
      this.setDuplicateTripFlags();

      // if (
      //   moment(event.appointmentTime).format("YYYY-MM-DD") !==
      //   moment(this.filterdataList[idx].appointmentTime).format(
      //     "YYYY-MM-DD"
      //   ) ||
      //   moment(event.scheduleTime).format("YYYY-MM-DD") !==
      //   moment(this.filterdataList[idx].scheduleTime).format("YYYY-MM-DD")
      // ) {
      //   // this.clearTrips();
      //   // this.getTrips();
      //   this.filterdataList.splice(idx, 1);
      // } else {
      //   this.filterdataList[idx] = event;
      // }
      this.editTripModalObj = null;
    }
  }

  openCancelModal(trip) {
    const scheduleTime = moment(trip.scheduleTime);
    const nowPlus24Hours = moment.tz(this.timeZone).add(24, 'hours');
  
    if (scheduleTime.isAfter(nowPlus24Hours)) {
      this.cancelTripModalObj = trip;
    } else {
      sweetAlert('Alert', 'Trip cannot be cancelled within 24 hours of its pickup time, Please contact your dispatcher for assistance.', 'warning', 'OK');
    }
  }
  
  onCancelTrip(evt) {
    if (evt) {
      const index = this.filterdataList.findIndex(
        (trip) => trip._id === evt._id
      );
      this.filterdataList.splice(index, 1);
      this.removeTripFromDataList(evt._id);
      this.setDuplicateTripFlags();
    }
    this.cancelTripModalObj = null;
    // this.isNoShow = false;
  }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  openWillCallModal(trip){
    this.willCallObj = trip;
  }

  closeWillCallModal(evt){
    this.willCallObj = evt;
    this.getTrips();
  }

isNewTrip(createdAt:any){
  const createdMoment = moment.tz(createdAt, this.timeZone);
  const now = moment.tz(this.timeZone);
  return now.isBetween(createdMoment, createdMoment.clone().add(5, 'minutes'), null, '[)');
}
isWithin24Hours(createdAt: any) {
  const createdMoment = moment.tz(createdAt, this.timeZone);
  const now = moment.tz(this.timeZone);
  return now.isBetween(createdMoment, createdMoment.clone().add(24, 'hours'), null, '[)');
}

 togglePopup(event: MouseEvent) {
    event.stopPropagation(); // Prevent outside click listener from firing
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    this.isOpen = false;
  }

  openCancelReasonModal(assign) {
    this.cancelReasonModalObj = assign;
  }

  onSortChange(column, direction) {
    if (this.sortColumn === column) {
      this.sortOrder = direction === 'asc' ? 'desc' : 'asc'; // toggle sort order
    } else {
      this.sortColumn = column;
      this.sortOrder = 'asc'; // reset to asc for new column
    }
  }

  async unConfirmIntake(trip) {
    const confirm = await sweetAlert(
      "Alert!",
      `Are you sure you want to unconfirm this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (confirm.value) {
      this.updateIntakeStatus(trip, "unconfirmed");
    }
  }

  async confirmIntake(trip) {
    const confirm = await sweetAlert(
      "Alert!",
      `Are you sure you want to confirm this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (confirm.value) {
      this.updateIntakeStatus(trip, "confirmed");
    }
  }

  placeMyPatient(trip: any) {
    const client = trip ? trip.client : null;
    if (client) {
      this.router.navigate(['/placement', client, 'patient', 'add']);
    } else {
      this.router.navigate(['/placement/patient/add']);
    }
  }

  updateIntakeStatus(trip, intakeStatus) {
    const payload = {
      _id: trip._id,
      intakeStatus
    }
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          trip.intakeStatus = data.intakeStatus
          if (intakeStatus === 'confirmed') {
            const idx_main = this.dataList.findIndex((trip) => trip._id === data._id);
            this.dataList.splice(idx_main, 1);
            const idx_filter = this.filterdataList.findIndex((trip) => trip._id === data._id);
            this.filterdataList.splice(idx_filter, 1);
            this.setDuplicateTripFlags();
          }
        }
      });
  }
}